import { Component, inject, output, signal } from '@angular/core';
import { TranslatePipe, TranslateService, _ } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/_base/base.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth/auth.service';
import deepDiff from 'deep-diff';
import { captureException } from '@sentry/angular';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './introduction.component.html',
  standalone: true,
  selector: 'app-introduction',
  imports: [MatButtonModule, TranslatePipe],
  styles: `
    button[mat-flat-button] {
      --mdc-filled-button-container-height: 50px;
    }
    button[mat-button] {
      --mdc-text-button-container-height: 50px;
      --mdc-text-button-label-text-color: rgb(var(--color-text-6));
    }
  `,
})
export class IntroductionComponent extends BaseComponent {
  readonly authService = inject(AuthService);
  readonly snackbar = inject(MatSnackBar);
  readonly translate = inject(TranslateService);

  readonly skipping = signal(false);

  readonly continue = output<void>();

  onSkip() {
    this.skipping.set(true);

    this.authService
      .updateProfile({
        diffs: deepDiff({ finishedOnboarding: false }, { finishedOnboarding: true }) ?? [],
      })
      .subscribe({
        next: () => {
          this.skipping.set(false);
        },
        error: (error) => {
          captureException(error);
          this.snackbar.open(
            this.translate.instant(_('error.error-occured')),
            this.translate.instant(_('common.close')),
            { panelClass: 'snackbar-error' },
          );
          this.skipping.set(false);
        },
      });
  }
}
